import decode from 'jwt-decode';
import getTokens from './getTokens';

const tokens = getTokens();

const ownerId = tokens ? decode(JSON.parse(tokens).access).customer_id : null;
export default ownerId;

export function getOwnerId() {
  const userTokens = getTokens();
  return userTokens ? decode(JSON.parse(userTokens).access).customer_id : null;
}
